import { useTranslation } from 'react-i18next'
import { FormGroup } from 'components/form'
import { Formik } from 'interfaces'
import { DriverFormValues } from '../../interfaces/driver-form'
import { DriversProfileImageUpload } from './DriversProfileImageUpload'

interface Props extends Formik<DriverFormValues> {
  method?: 'post' | 'patch'
}

export const DriversDetailsFields = (props:Props) => {
  const { formik, method } = props
  const { t } = useTranslation()

  return (
    <div>
      <h2 className="text-xl mb-5">{t('details')}</h2>
      <div className="driver-form-child-container">
        <FormGroup
          label="firstname"
          placeholder={t<string>('driversFirstName')}
          hasError={!!(formik.touched.first_name && formik.errors.first_name)}
          errorText={formik.errors.first_name}
          {...formik.getFieldProps('first_name')}
        />
        <FormGroup
          label="lastname"
          placeholder={t<string>('driversLastName')}
          hasError={!!(formik.touched.last_name && formik.errors.last_name)}
          errorText={formik.errors.last_name}
          {...formik.getFieldProps('last_name')}
        />
        <FormGroup
          label="fatherName"
          placeholder={t<string>('driversFatherName')}
          hasError={!!(formik.touched.father_name && formik.errors.father_name)}
          errorText={formik.errors.father_name}
          {...formik.getFieldProps('father_name')}
        />
        <FormGroup
          label="email"
          placeholder={t<string>('driversEmail')}
          hasError={!!(formik.touched.email && formik.errors.email)}
          errorText={formik.errors.email}
          disabled={method === 'patch'}
          {...formik.getFieldProps('email')}
        />
        <FormGroup
          label="telephone"
          placeholder={t<string>('driversPhone')}
          hasError={!!(formik.touched.phone_number && formik.errors.phone_number)}
          errorText={formik.errors.phone_number}
          {...formik.getFieldProps('phone_number')}
        />
        <FormGroup
          label="residency"
          placeholder={t<string>('driversResidency')}
          hasError={!!(formik.touched.residency && formik.errors.residency)}
          errorText={formik.errors.residency}
          {...formik.getFieldProps('residency')}
        />
        <FormGroup
          label="address"
          placeholder={t<string>('driversAddress')}
          hasError={!!(formik.touched.address && formik.errors.address)}
          errorText={formik.errors.address}
          {...formik.getFieldProps('address')}
        />
        <FormGroup
          label="password"
          type="password"
          disabled={method === 'patch'}
          placeholder={t<string>('driversPassword')}
          hasError={!!(formik.touched.password && formik.errors.password)}
          errorText={formik.errors.password}
          {...formik.getFieldProps('password')}
        />
        <DriversProfileImageUpload<DriverFormValues> formik={formik} formikKey="image" />
      </div>
    </div>
  )
}
